import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { RolesService } from '../../../roles/services/roles-service';
import { UsersService } from '../../services/users-service';
import { QueryModel } from '../../../../shared/Models/queryModel';
import { Router } from '@angular/router';
import { uploadService } from '../../../../shared/uploadService';
import { combineLatest, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-edit-user-roles',
  templateUrl: './edit-user-roles.component.html',
  styleUrls: ['./edit-user-roles.component.scss'],
})
export class EditUserRolesComponent implements OnInit {
  model = {} as any;
  roles = [];
  query = new QueryModel();
  uploadThumbnail: boolean = false;
  validPhoto: boolean = false;
  formData = new FormData();

  constructor(
    private route : Router,
    private diagRef: NbDialogRef<EditUserRolesComponent>,
    private service: UsersService,
    private toast: NbToastrService,
    private roleService: RolesService,
    private uploadservice : uploadService
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
    this.query.pageSize = 100;
    this.roleService.getAll(this.query, '').subscribe((res: any) => {
      this.roles = res.result;
    });
    if( this.model.profilePictureFilePath=='')
    {
      this.uploadThumbnail = true;
    }
   
  }

      getFormData(event) {
    this.formData = event;
    if (event) this.validPhoto = true;
  }

  update() {
    this.service.putBulk(this.model, `${this.model.id}/roles`).subscribe((res) => {
      this.diagRef.close('true');
      this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 });
    });
  }

      removePhoot() {
    this.uploadThumbnail = true;
    this.validPhoto = false;
  }


  save() {
    const attachment$ = this.validPhoto ? this.uploadservice.uploadImage(this.formData) : of(null);

    combineLatest([ attachment$])
      .pipe(
        switchMap(([attachment]) => {
          if (attachment) {
            this.model.profilePictureFileName = attachment && attachment.fileName ? attachment.fileName : '';
          }
          return this.service.put(this.model.id, {  
      userName: this.model.email,
      email: this.model.email,
      name : this.model.name,
      rolesIds : this.model.rolesIds,
      profilePictureFileName : this.model.profilePictureFileName
    });
        })
      )
      .subscribe({
        next: (res) => {
          this.diagRef.close('true');
          this.toast.show('تم تعديل المستخدم بنجاح', '', { status: 'success', duration: 3000 });
        },
        error: (err) => {
          this.diagRef.close('true');
          this.toast.danger('خطأ في تعديل المستخدم ', 'خطأ', { status: 'success', duration: 3000 });
        },
      });
  }

  close() {
    this.diagRef.close();
  }
}
